import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=659e8f40&scoped=true&"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=659e8f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e8f40",
  null
  
)

export default component.exports